export const ALLEGRO_MARKETPLACES = [{
  value: 'ALLEGRO.SK',
  label: 'allegro.sk',
}, {
  value: 'ALLEGRO.PL',
  label: 'allegro.pl',
}, {
  value: 'ALLEGRO.CZ',
  label: 'allegro.cz',
}, {
  value: 'ALLEGRO.HU',
  label: 'allegro.hu',
}];

export const KAUFLAND_MARKETPLACES = [{
  value: 'KAUFLAND.CZ',
  label: 'kaufland.cz',
}, {
  value: 'KAUFLAND.SK',
  label: 'kaufland.sk',
}, {
  value: 'KAUFLAND.PL',
  label: 'kaufland.pl',
}, {
  value: 'KAUFLAND.DE',
  label: 'kaufland.de',
}, {
  value: 'KAUFLAND.AT',
  label: 'kaufland.at',
}, {
  value: 'KAUFLAND.FR',
  label: 'kaufland.fr',
}, {
  value: 'KAUFLAND.IT',
  label: 'kaufland.it',
}, {
  value: 'KAUFLAND.ES',
  label: 'kaufland.es',
}, {
  value: 'KAUFLAND.NL',
  label: 'kaufland.nl',
}];
